import { render, staticRenderFns } from "./chat-request-user-list.html?vue&type=template&id=3c0976cc&scoped=true&external"
import script from "./chat-request-user-list.js?vue&type=script&lang=js&external"
export * from "./chat-request-user-list.js?vue&type=script&lang=js&external"
import style0 from "./chat-request-user-list.scss?vue&type=style&index=0&id=3c0976cc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0976cc",
  null
  
)

export default component.exports